import { PublicClientApplication } from '@azure/msal-browser';
import { getCurrentInstance, toRefs } from 'vue';

export function useMsal(): PublicClientApplication {
    const internalInstance = getCurrentInstance();
    if (!internalInstance) {
        throw 'useMsal() cannot be called outside the setup() function of a component';
    }

    const { instance} = toRefs(internalInstance.appContext.config.globalProperties.$msal);
    if (!instance.value) {
        throw 'Please install the msalPlugin';
    }

    return instance.value;
}
